<template>
    <div class="CanvasWrapper p-5 d-flex justify-content-center align-items-start m-0 position-relative overflow-auto">
        <div ref="canvasWrapperHere" class=" position-absolute inset-0" @contextmenu="handler($event)">
            <div :class="`canvas-box position-relative ${CurrentCanvasIndex == index ? 'activeone' : 'hideit'}`"
                v-for="(canvas, index) of CanvasList" v-bind:key="index">

                <div @mousemove="onMouseMoveEve($event)" @mousedown="onMouseDowneve($event)" @dragenter.prevent
                    @dragover.prevent @drop="onCanvasDrop($event)" :id="`${canvas.id}`" :ref="`canvasRef_${index}`"
                    :class="`${getcreateShapeType !== '' ? 'croshair' : ''} WrapperDiv position-relative`"
                    v-bind:style="{ backgroundColor: canvas.bgColor, width: canvas.size.width * canvas.zoomRatio + 'px', height: canvas.size.height * canvas.zoomRatio + 'px' }">
                    <div class="containerWrapperD">
                        <div @focusout="onsetobj($event, ObjectItem.type, ObjectItem.id)"
                            @dblclick="editonDblClick($event, ObjectItem.type)" :list-index="key"
                            :data-id-t="ObjectItem.id" :data-type="ObjectItem.type"
                            @mousedown="setCurrentTarget($event, ObjectItem.id)"
                            v-for="(ObjectItem, key) of canvas.objects" v-bind:key="ObjectItem.id"
                            :class="`position-absolute ${ObjectItem.lock === true && 'locked'} targetE objTarget_${key} ${ObjectItem.type === 'img' && 'inset-0 overflow-hidden'}`"
                            v-bind:style="{ top: ObjectItem.top * canvas.zoomRatio + 'px', opacity: ObjectItem.opacity, left: ObjectItem.left * canvas.zoomRatio + 'px', width: ObjectItem.isAuto === true ? 'auto' : ObjectItem.type === 'Line' ? (ObjectItem.width + 29) * canvas.zoomRatio + 'px' : ObjectItem.type === 'text' ? 400 * canvas.zoomRatio + 'px' : ObjectItem.width * canvas.zoomRatio + 'px', textAlign: ObjectItem.align, transform: addRotate(ObjectItem), height: ObjectItem?.cType === 'full' || ObjectItem.type === 'qrCodeApp' || ObjectItem.type === 'Ellipse' || ObjectItem.type === 'Triangle' || ObjectItem.type === 'Rectangle' || ObjectItem.type === 'img' || ObjectItem.type === 'stickers' ? (ObjectItem.height * canvas.zoomRatio) + 'px' : 'auto' }">
                            <transition appear @after-enter="transitionComplete"
                                :enter-active-class="ObjectItem.animationLoop === false ? ObjectItem.animationClass : ''">

                                <div :key="ObjectItem.id + 'TExt' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} ${ObjectItem.editable === false ? 'noPointer' : ''}`"
                                    :style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), }"
                                    v-if="ObjectItem.type === 'text'">
                                    <div :key="ObjectItem.id + 'TExt222' + ObjectItem.fontfamily"
                                        @focusout="onInputedit" :contenteditable="ObjectItem.editable"
                                        class="wordbsreak select-text" v-bind:style="{
                                            color: ObjectItem.color,
                                            fontSize: ObjectItem.fs * canvas.zoomRatio + 'px',
                                            fontWeight: ObjectItem.fw,
                                            fontFamily: ObjectItem.fontfamily,
                                            textDecoration: ObjectItem.underline === true ? 'underline' : 'none',
                                            fontStyle: ObjectItem.italic === true ? 'italic' : 'normal',
                                            lineHeight: ObjectItem.lineHeight,
                                            letterSpacing: ObjectItem.letterSpacing + 'px',
                                            textTransform: ObjectItem.textTransform,
                                            textShadow: addEffect(ObjectItem),
                                            wordBreak: 'break-word',
                                            whiteSpace: 'normal',
                                            background: (getActiveCanvasObjProps && getActiveCanvasObjProps.id === ObjectItem.id)
                                                ? 'transparent'
                                                : 'rgba(200,200,200,0.3)',
                                            borderRadius: '6px',
                                            transition: 'background 0.2s',
                                            ...createHollow(ObjectItem),
                                            ...createSplice(ObjectItem),
                                            ...createEcho(ObjectItem),
                                            ...createGlitch(ObjectItem),
                                            ...createNeon(ObjectItem)
                                        }">
                                        <div>
                                            <span>{{ ObjectItem.text[0] }}</span>
                                        </div>
                                    </div>


                                </div>
                                <!-- <div class="noPointer" v-if="ObjectItem.type === 'img'" v-bind:style="{opacity:ObjectItem.opacity,backgroundImage: `url(${ObjectItem.url})`,backgroundSize:'cover' ,backgroundRepeat:'no-repeat',backgroundPosition:'center center', width: ObjectItem.width * canvas.zoomRatio +'px', height: ObjectItem.height * canvas.zoomRatio + 'px' ,top:ObjectItem.top * canvas.zoomRatio + 'px',left:ObjectItem.left * canvas.zoomRatio + 'px' }">
                            </div>  -->
                                <div :key="ObjectItem.id + 'img' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} ${ObjectItem.adjustment === 'burn_effect' ? 'kenburnClass' : ''} noPointer position-absolute inset-0 `"
                                    v-if="ObjectItem.type === 'img' && ObjectItem.orientation === 0"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), opacity: ObjectItem.opacity, backgroundImage: `url(${ObjectItem.url})`, backgroundSize: ObjectItem.adjustment === 'cover' || ObjectItem.adjustment === 'burn_effect' ? 'cover' : ObjectItem.adjustment === 'contain' ? 'contain' : ObjectItem.adjustment === 'stretch' ? '100% 100%' : '', backgroundRepeat: ObjectItem.adjustment === 'tile' ? 'repeat' : 'no-repeat', backgroundPosition: 'center center', borderRadius: ObjectItem.borderRadius + 'px', filter: `brightness(${ObjectItem.brightness}%) contrast(${ObjectItem.contrast}%) saturate(${ObjectItem.saturation}%)` }">
                                </div>
                                <div :key="ObjectItem.id + 'stickers' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer position-absolute inset-0`"
                                    v-if="ObjectItem.type === 'stickers'" v-bind:style="{
                                        ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2),
                                        opacity: ObjectItem.opacity,
                                        width: '100%', height: '100%',
                                        borderRadius: ObjectItem.borderRadius + 'px',
                                        color: ObjectItem.color + ' !important',
                                        // top: ObjectItem.top * canvas.zoomRatio + 'px', left: ObjectItem.left * canvas.zoomRatio + 'px'
                                    }" v-html="ObjectItem.svgContent"></div>
                                <imageOrientation v-if="ObjectItem.type === 'img' && ObjectItem.orientation !== 0"
                                    :url="ObjectItem.url" :orientation="ObjectItem.orientation" />
                                <div :key="ObjectItem.id + 'video' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer overflow-hidden`"
                                    v-if="ObjectItem.type === 'video'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), borderRadius: ObjectItem.borderRadius + 'px', opacity: ObjectItem.opacity, width: ObjectItem.width * canvas.zoomRatio + 'px', height: ObjectItem.height * canvas.zoomRatio + 'px', top: ObjectItem.top * canvas.zoomRatio + 'px', left: ObjectItem.left * canvas.zoomRatio + 'px' }">
                                    <video crossorigin="anonymous" muted loop="" autoplay preload="auto"
                                        :src="ObjectItem.url" class="adujustVideo"></video>

                                </div>
                                <div :key="ObjectItem.id + 'Ellipse' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer overflow-hidden`"
                                    v-if="ObjectItem.type === 'Ellipse'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), border: `${ObjectItem.borderWidth}px solid ${ObjectItem.borderColor}`, borderRadius: `${ObjectItem.borderRadius}%`, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: '100%', height: '100%', top: ObjectItem.top * canvas.zoomRatio + 'px', left: ObjectItem.left * canvas.zoomRatio + 'px' }">
                                </div>
                                <div :key="ObjectItem.id + 'Rectangle' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer overflow-hidden`"
                                    v-if="ObjectItem.type === 'Rectangle'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), border: `${ObjectItem.borderWidth}px solid ${ObjectItem.borderColor}`, borderRadius: `${ObjectItem.borderRadius}px`, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: '100%', height: '100%', top: ObjectItem.top * canvas.zoomRatio + 'px', left: ObjectItem.left * canvas.zoomRatio + 'px' }">
                                </div>
                                <div :key="ObjectItem.id + 'Line' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer overflow-hidden pt-2`"
                                    v-if="ObjectItem.type === 'Line'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), borderTop: `${ObjectItem.borderWidth}px solid ${ObjectItem.borderColor}`, borderRadius: `${ObjectItem.borderRadius}%`, backgroundColor: 'transparent', opacity: ObjectItem.opacity, width: '100%', height: 2 + 'px', top: ObjectItem.top * canvas.zoomRatio + 'px', left: ObjectItem.left * canvas.zoomRatio + 'px' }">
                                </div>

                                <div :key="ObjectItem.id + 'Triangle' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer overflow-hidden`"
                                    v-if="ObjectItem.type === 'Triangle'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: '100%', height: '100%', top: ObjectItem.top * canvas.zoomRatio + 'px', left: ObjectItem.left * canvas.zoomRatio + 'px' }">
                                </div>
                                <div :key="ObjectItem.id + 'youtubeApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer overflow-hidden`"
                                    v-if="ObjectItem.type === 'youtubeApp'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: ObjectItem.width * canvas.zoomRatio + 'px', height: ObjectItem.height * canvas.zoomRatio + 'px', top: ObjectItem.top * canvas.zoomRatio + 'px', left: ObjectItem.left * canvas.zoomRatio + 'px' }">
                                    <youtubeApp :width="ObjectItem.width * canvas.zoomRatio"
                                        :height="ObjectItem.height * canvas.zoomRatio" :src="ObjectItem.url" />
                                </div>
                                <div :key="ObjectItem.id + 'vimeoApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer overflow-hidden`"
                                    v-if="ObjectItem.type === 'vimeoApp'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: ObjectItem.width * canvas.zoomRatio + 'px', height: ObjectItem.height * canvas.zoomRatio + 'px', top: ObjectItem.top * canvas.zoomRatio + 'px', left: ObjectItem.left * canvas.zoomRatio + 'px' }">
                                    <vimeoApp :width="ObjectItem.width * canvas.zoomRatio"
                                        :height="ObjectItem.height * canvas.zoomRatio" :src="ObjectItem.url" />
                                </div>
                                <div :key="ObjectItem.id + 'newsApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer overflow-hidden`"
                                    v-if="ObjectItem.type === 'newsApp'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: ObjectItem.width * canvas.zoomRatio + 'px', height: ObjectItem.height * canvas.zoomRatio + 'px', top: ObjectItem.top * canvas.zoomRatio + 'px', left: ObjectItem.left * canvas.zoomRatio + 'px' }">
                                    <newsApp :id="ObjectItem.id" :width="ObjectItem.width * canvas.zoomRatio"
                                        :height="ObjectItem.height * canvas.zoomRatio" :src="ObjectItem.url" />
                                </div>
                                <div :key="ObjectItem.id + 'clockApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer overflow-hidden`"
                                    v-if="ObjectItem.type === 'clockApp'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, opacity: ObjectItem.opacity, }">
                                    <clockApp :fs="ObjectItem.fs * canvas.zoomRatio" :format="ObjectItem.format"
                                        :color="ObjectItem.color" :showSeconds="ObjectItem.showSeconds"
                                        :timeZone="ObjectItem.timezone" />
                                </div>
                                <div :key="ObjectItem.id + 'calendarApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer overflow-hidden`"
                                    v-if="ObjectItem.type === 'calendarApp'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, opacity: ObjectItem.opacity, }">
                                    <calendarApp :zoomRatio="canvas.zoomRatio" :lang="ObjectItem.lang"
                                        :beginweek="ObjectItem.beginweek" :Hcolor="ObjectItem.Hcolor"
                                        :Dcolor="ObjectItem.Dcolor" :Tcolor="ObjectItem.Tcolor"
                                        :bgColorR="ObjectItem.bgColorR" :bgColorL="ObjectItem.bgColorL"
                                        :cType="ObjectItem.cType" :calcWidth="ObjectItem.width * canvas.zoomRatio"
                                        :width="ObjectItem.width * canvas.zoomRatio + 'px'"
                                        :height="ObjectItem.cType !== 'full' ? 'auto' : ObjectItem.height * canvas.zoomRatio + 'px'"
                                        :fs="ObjectItem.fs * canvas.zoomRatio" :format="ObjectItem.format"
                                        :color="ObjectItem.color" :showSeconds="ObjectItem.showSeconds"
                                        :timeZone="ObjectItem.timezone" />
                                </div>
                                <div :key="ObjectItem.id + 'webpageApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} w-100  noPointer overflow-hidden`"
                                    v-if="ObjectItem.type === 'webpageApp'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, backgroundColor: ObjectItem.bgColor, opacity: ObjectItem.opacity, width: ObjectItem.width * canvas.zoomRatio + 'px', height: ObjectItem.height * canvas.zoomRatio + 'px', top: ObjectItem.top * canvas.zoomRatio + 'px', left: ObjectItem.left * canvas.zoomRatio + 'px' }">
                                    <WebpageApp :width="ObjectItem.width * canvas.zoomRatio"
                                        :height="ObjectItem.height * canvas.zoomRatio" :src="ObjectItem.url"
                                        :isScroll="ObjectItem.isScroll" :scrolltoPhrase="ObjectItem.scrolltoPhrase"
                                        :zoomRatio="canvas.zoomRatio" :scrollSpeed="Number(ObjectItem.scrollSpeed)" />
                                </div>
                                <div :key="ObjectItem.id + 'qrCodeApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer w-100 h-100 overflow-hidden`"
                                    v-if="ObjectItem.type === 'qrCodeApp'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, opacity: ObjectItem.opacity, width: ObjectItem.width * canvas.zoomRatio + 'px', height: ObjectItem.height * canvas.zoomRatio + 'px', top: ObjectItem.top * canvas.zoomRatio + 'px', left: ObjectItem.left * canvas.zoomRatio + 'px' }">
                                    <qrCodeApp :width="ObjectItem.width * canvas.zoomRatio"
                                        :height="ObjectItem.height * canvas.zoomRatio" :src="ObjectItem.url"
                                        :bg="ObjectItem.bgColor" :color="ObjectItem.lineColor"
                                        :noBG="ObjectItem.transparentBG" />
                                </div>
                                <div :key="ObjectItem.id + 'weatherApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop + key"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer overflow-hidden `"
                                    v-if="ObjectItem.type === 'weatherApp'"
                                    v-bind:style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), clipPath: ObjectItem.clip, opacity: ObjectItem.opacity }">
                                    <weatherApp :zoom="canvas.zoomRatio" :width="ObjectItem.width * canvas.zoomRatio"
                                        :height="ObjectItem.height * canvas.zoomRatio" :city="ObjectItem.city"
                                        :unit="ObjectItem.unit" :showForcast="ObjectItem.showForcast"
                                        :color="ObjectItem.color" :bgColor="ObjectItem.bgColor"
                                        :layout="ObjectItem.layout" :transparentbg="ObjectItem.transparentbg"
                                        :fontfamily="ObjectItem.fontfamily" :lang="ObjectItem.lang"
                                        :fontSize="ObjectItem.fs * canvas.zoomRatio" />
                                </div>
                                <div :key="ObjectItem.id + 'countdownApp' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} noPointer overflow-hidden`"
                                    v-if="ObjectItem.type === 'countdownApp'" v-bind:style="{
                                        ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2),
                                        clipPath: ObjectItem.clip,
                                        backgroundColor: ObjectItem.backgroundColor,
                                        opacity: ObjectItem.opacity,
                                        width: ObjectItem.width * canvas.zoomRatio + 'px',
                                        height: ObjectItem.height * canvas.zoomRatio + 'px',
                                        top: ObjectItem.top * canvas.zoomRatio + 'px',
                                        left: ObjectItem.left * canvas.zoomRatio + 'px'
                                    }">
                                    <countdownApp :mainText="ObjectItem.mainText" :targetDate="ObjectItem.targetDate"
                                        :displayFormat="ObjectItem.displayFormat" :labelColor="ObjectItem.labelColor"
                                        :valueColor="ObjectItem.valueColor"
                                        :backgroundColor="ObjectItem.backgroundColor"
                                        :fontSize="ObjectItem.fontSize * canvas.zoomRatio"
                                        :fontFamily="ObjectItem.fontFamily" :showLabels="ObjectItem.showLabels"
                                        :transparentBackground="ObjectItem.transparentBackground"
                                        :particleEffect="ObjectItem.particleEffect"
                                        :width="ObjectItem.width * canvas.zoomRatio"
                                        :height="ObjectItem.height * canvas.zoomRatio" />
                                </div>
                            </transition>
                            <div class="OverlayHov"></div>
                        </div>

                    </div>
                </div>
                <myDarg />
                <div class="context-menu" v-show="show" :style="style" ref="context" tabindex="0" @blur="close">
                    <div @click="SendBackward" class="ContextMenuItemContainer">
                        <div><svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M3.69995 12V13.5C3.69995 14.7702 4.7297 15.8 5.99995 15.8H13C14.2702 15.8 15.3 14.7702 15.3 13.5V5.49995C15.3 4.2297 14.2702 3.19995 13 3.19995H12V4.49995H13C13.5522 4.49995 14 4.94767 14 5.49995V13.5C14 14.0522 13.5522 14.5 13 14.5H5.99995C5.44767 14.5 4.99995 14.0522 4.99995 13.5V12H3.69995Z"
                                    fill="currentColor"></path>
                                <rect opacity="0.4" x="1.65" y="0.65" width="9.7" height="10.7" rx="1.35"
                                    stroke="currentColor" stroke-width="1.3"></rect>
                            </svg></div>
                        <div class="smallSize">SEND BACKWARD</div>
                    </div>
                    <div @click="SendToBack" class="ContextMenuItemContainer">
                        <div><svg width="16" height="16" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0">
                                <rect x="2.5" y="2.5" width="15" height="15" rx="2" fill="#212429"></rect>
                                <rect width="7.5" height="7.5" rx="1.5" fill="#ACB5BD"></rect>
                                <rect x="12.5" y="12.5" width="7.5" height="7.5" rx="1.5" fill="#ACB5BD"></rect>
                            </svg></div>
                        <div class="smallSize">SEND TO BACK</div>
                    </div>
                    <div @click="BrignForward" class="ContextMenuItemContainer">
                        <div><svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0">
                                <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd"
                                    d="M3.69995 11.5V13.5C3.69995 14.7702 4.7297 15.8 5.99995 15.8H13C14.2702 15.8 15.3 14.7702 15.3 13.5V5.49995C15.3 4.2297 14.2702 3.19995 13 3.19995H11V4.49995H13C13.5522 4.49995 14 4.94767 14 5.49995V13.5C14 14.0522 13.5522 14.5 13 14.5H5.99995C5.44767 14.5 4.99995 14.0522 4.99995 13.5V11.5H3.69995Z"
                                    fill="currentColor"></path>
                                <rect x="1.35" y="0.85" width="10.3" height="11.3" rx="1.65" stroke="currentColor"
                                    stroke-width="1.3"></rect>
                            </svg></div>
                        <div class="smallSize">BRIGN FORWARD</div>
                    </div>
                    <div @click="bringFronts" class="ContextMenuItemContainer">
                        <div><svg width="16" height="16" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0">
                                <rect width="7.5" height="7.5" rx="1.5" fill="#ACB5BD"></rect>
                                <rect x="12.5" y="12.5" width="7.5" height="7.5" rx="1.5" fill="#ACB5BD"></rect>
                                <rect x="2.5" y="2.5" width="15" height="15" rx="2" fill="#212429"></rect>
                            </svg></div>
                        <div class="smallSize">BRIGN TO FRONT</div>
                    </div>
                    <hr class="divider" />
                    <div @click="removeBGofImage" class="ContextMenuItemContainer">
                        <div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-magic" viewBox="0 0 16 16">
                                <path
                                    d="M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0zm4.5.035A.5.5 0 0 0 13.293 2L12 3.293a.5.5 0 1 0 .707.707zM7.293 4A.5.5 0 1 0 8 3.293L6.707 2A.5.5 0 0 0 6 2.707zm-.621 2.5a.5.5 0 1 0 0-1H4.843a.5.5 0 1 0 0 1zm8.485 0a.5.5 0 1 0 0-1h-1.829a.5.5 0 0 0 0 1zM13.293 10A.5.5 0 1 0 14 9.293L12.707 8a.5.5 0 1 0-.707.707zM9.5 11.157a.5.5 0 0 0 1 0V9.328a.5.5 0 0 0-1 0zm1.854-5.097a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0z" />
                            </svg></div>
                        <div class="smallSize">REMOVE BACKGROUND</div>
                    </div>
                    <div @click="LockObj" v-if="!checkLock" class="ContextMenuItemContainer">
                        <div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"
                                viewBox="0 0 24 24" class="flex-shrink-0">
                                <path fill="currentColor"
                                    d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2ZM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6Zm9 14H6V10h12v10Zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Z">
                                </path>
                            </svg></div>
                        <div class="smallSize">LOCK</div>
                    </div>
                    <div @click="unLockObj" v-else class="ContextMenuItemContainer">
                        <div> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"
                                viewBox="0 0 24 24" class="flex-shrink-0">
                                <path fill="currentColor"
                                    d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2Zm0 12H6V10h12v10Zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Z">
                                </path>
                            </svg></div>
                        <div class="smallSize">UNLOCK</div>
                    </div>
                    <div @click="cloneObject" class="ContextMenuItemContainer">
                        <div><svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M4.99995 3.20001H2.99995C1.7297 3.20001 0.699951 4.22976 0.699951 5.50001V13.5C0.699951 14.7703 1.7297 15.8 2.99995 15.8H9.99995C11.2702 15.8 12.3 14.7703 12.3 13.5V11.5H11V13.5C11 14.0523 10.5522 14.5 9.99995 14.5H2.99995C2.44767 14.5 1.99995 14.0523 1.99995 13.5V5.50001C1.99995 4.94773 2.44767 4.50001 2.99995 4.50001H4.99995V3.20001Z"
                                    fill="currentColor"></path>
                                <rect x="4.35" y="0.85" width="10.3" height="11.3" rx="1.65" stroke="currentColor"
                                    stroke-width="1.3"></rect>
                            </svg></div>
                        <div class="smallSize">DUPLICATE</div>
                    </div>
                    <div @click="deleteObject" class="ContextMenuItemContainer">
                        <div><svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M11.2257 1.49541C11.0196 0.860613 10.4892 0.449951 9.88745 0.449951H6.94509L6.83315 0.454464C6.53927 0.482116 6.26083 0.605595 6.03649 0.807762C5.81214 1.00993 5.65302 1.28076 5.5812 1.58266L5.40439 2.53184L5.38371 2.61533C5.34354 2.74757 5.26487 2.86309 5.15889 2.94545C5.05291 3.02782 4.92502 3.07284 4.79339 3.07413H2.52049L2.4499 3.07939C2.32372 3.09984 2.20877 3.16761 2.12613 3.27026C2.04349 3.37291 1.99872 3.50356 2.00003 3.63822C2.00003 3.94961 2.23316 4.20232 2.5212 4.20232H14.3128L14.3833 4.19706C14.5094 4.17663 14.6243 4.10897 14.7069 4.00647C14.7895 3.90398 14.8344 3.77351 14.8332 3.63898C14.8342 3.56582 14.8214 3.49319 14.7957 3.42523C14.77 3.35728 14.7319 3.29533 14.6835 3.24294C14.6351 3.19055 14.5774 3.14873 14.5136 3.1199C14.4499 3.09106 14.3814 3.07576 14.3121 3.07488H12.0399L11.96 3.06961C11.8292 3.05009 11.7076 2.98777 11.6121 2.89142C11.5167 2.79508 11.4524 2.66957 11.4281 2.5326L11.2592 1.61801L11.225 1.49616L11.2257 1.49541ZM10.4942 3.07488C10.4702 3.01046 10.4498 2.94467 10.4329 2.87782L10.4058 2.75297L10.2446 1.87298C10.2271 1.79986 10.1899 1.73365 10.1375 1.68229C10.0852 1.63092 10.0199 1.59659 9.94948 1.58341L9.88817 1.57814H6.94509C6.87727 1.57818 6.81074 1.59765 6.7526 1.63448C6.69446 1.67131 6.64689 1.72411 6.61499 1.78724L6.59645 1.83838L6.42748 2.75297C6.40609 2.86428 6.37686 2.97184 6.33907 3.07413H10.4942V3.07488ZM13.3916 5.50426C13.6554 5.52682 13.8565 5.75772 13.8707 6.03526L13.8636 6.1902L13.6397 9.08664L13.4045 11.9131C13.3546 12.4772 13.3104 12.9541 13.2719 13.3286C13.1378 14.6343 12.335 15.4421 11.1237 15.4654C9.30275 15.5027 7.48126 15.5015 5.66034 15.4617C4.48396 15.4354 3.69258 14.6193 3.5614 13.3332L3.47014 12.3862L3.31187 10.5488L3.14931 8.53308L2.96394 6.11122C2.95144 5.96401 2.99465 5.81755 3.08415 5.70383C3.17365 5.59011 3.30216 5.51837 3.44162 5.50426C3.70542 5.48169 3.93784 5.67424 3.99274 5.94576L4.01413 6.16763L4.1888 8.43681L4.37916 10.7887C4.46471 11.8071 4.53815 12.6314 4.59732 13.2098C4.67218 13.9424 5.03793 14.3192 5.68173 14.3335C7.42989 14.3734 9.23082 14.3741 11.1045 14.3373C11.7875 14.3237 12.1589 13.9507 12.2352 13.2038L12.3258 12.2621C12.3521 11.9718 12.3799 11.6507 12.4099 11.3024L12.601 8.98962L12.8305 6.02172C12.8389 5.88722 12.8932 5.76049 12.9834 5.66505C13.0736 5.5696 13.1936 5.51194 13.321 5.50275L13.3923 5.50426H13.3916Z"
                                    fill="currentColor"></path>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M11.2257 1.49541C11.0196 0.860613 10.4892 0.449951 9.88745 0.449951H6.94509L6.83315 0.454464C6.53927 0.482116 6.26083 0.605595 6.03649 0.807762C5.81214 1.00993 5.65302 1.28076 5.5812 1.58266L5.40439 2.53184L5.38371 2.61533C5.34354 2.74757 5.26487 2.86309 5.15889 2.94545C5.05291 3.02782 4.92502 3.07284 4.79339 3.07413H2.52049L2.4499 3.07939C2.32372 3.09984 2.20877 3.16761 2.12613 3.27026C2.04349 3.37291 1.99872 3.50356 2.00003 3.63822C2.00003 3.94961 2.23316 4.20232 2.5212 4.20232H14.3128L14.3833 4.19706C14.5094 4.17663 14.6243 4.10897 14.7069 4.00647C14.7895 3.90398 14.8344 3.77351 14.8332 3.63898C14.8342 3.56582 14.8214 3.49319 14.7957 3.42523C14.77 3.35728 14.7319 3.29533 14.6835 3.24294C14.6351 3.19055 14.5774 3.14873 14.5136 3.1199C14.4499 3.09106 14.3814 3.07576 14.3121 3.07488H12.0399L11.96 3.06961C11.8292 3.05009 11.7076 2.98777 11.6121 2.89142C11.5167 2.79508 11.4524 2.66957 11.4281 2.5326L11.2592 1.61801L11.225 1.49616L11.2257 1.49541ZM10.4942 3.07488C10.4702 3.01046 10.4498 2.94467 10.4329 2.87782L10.4058 2.75297L10.2446 1.87298C10.2271 1.79986 10.1899 1.73365 10.1375 1.68229C10.0852 1.63092 10.0199 1.59659 9.94948 1.58341L9.88817 1.57814H6.94509C6.87727 1.57818 6.81074 1.59765 6.7526 1.63448C6.69446 1.67131 6.64689 1.72411 6.61499 1.78724L6.59645 1.83838L6.42748 2.75297C6.40609 2.86428 6.37686 2.97184 6.33907 3.07413H10.4942V3.07488ZM13.3916 5.50426C13.6554 5.52682 13.8565 5.75772 13.8707 6.03526L13.8636 6.1902L13.6397 9.08664L13.4045 11.9131C13.3546 12.4772 13.3104 12.9541 13.2719 13.3286C13.1378 14.6343 12.335 15.4421 11.1237 15.4654C9.30275 15.5027 7.48126 15.5015 5.66034 15.4617C4.48396 15.4354 3.69258 14.6193 3.5614 13.3332L3.47014 12.3862L3.31187 10.5488L3.14931 8.53308L2.96394 6.11122C2.95144 5.96401 2.99465 5.81755 3.08415 5.70383C3.17365 5.59011 3.30216 5.51837 3.44162 5.50426C3.70542 5.48169 3.93784 5.67424 3.99274 5.94576L4.01413 6.16763L4.1888 8.43681L4.37916 10.7887C4.46471 11.8071 4.53815 12.6314 4.59732 13.2098C4.67218 13.9424 5.03793 14.3192 5.68173 14.3335C7.42989 14.3734 9.23082 14.3741 11.1045 14.3373C11.7875 14.3237 12.1589 13.9507 12.2352 13.2038L12.3258 12.2621C12.3521 11.9718 12.3799 11.6507 12.4099 11.3024L12.601 8.98962L12.8305 6.02172C12.8389 5.88722 12.8932 5.76049 12.9834 5.66505C13.0736 5.5696 13.1936 5.51194 13.321 5.50275L13.3923 5.50426H13.3916Z"
                                    stroke="currentColor" stroke-width="0.32"></path>
                            </svg></div>
                        <div class="smallSize">REMOVE</div>
                    </div>
                </div>
            </div>
        </div>
        <input type="hidden" name="hiddenval" value="" />
        <input type="hidden" name="hiddenvalresolution" value="" />
        <button id="addele" @click="addPropsInscreen">test</button>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

import myDarg from "../components/draggableItem"
import youtubeApp from "../components/apps/youtube.vue"
import vimeoApp from "../components/apps/vimeo.vue"
import newsApp from "../components/apps/News.vue"
import imageOrientation from "../components/ImageOrientation.vue"
import clockApp from "../components/apps/Clock.vue"
import calendarApp from "../components/apps/Calendar.vue"
import WebpageApp from "../components/apps/WebPage.vue"
import qrCodeApp from "../components/apps/QRcode.vue"
import weatherApp from "../components/apps/weather.vue"
import countdownApp from "../components/apps/Countdown.vue"

export default {
    name: 'CanvasComponent',

    components: {
        myDarg,
        youtubeApp,
        vimeoApp,
        newsApp,
        imageOrientation,
        clockApp,
        calendarApp,
        WebpageApp,
        qrCodeApp,
        weatherApp,
        countdownApp
    },
    data() {
        return {
            left: 0, // left position
            top: 0, // top position
            show: false, // affect display of context menu
            startX: null,
            startY: null,
            shapeWidth: 0,
            shapeHeight: 0,
            currentShapeID: null,
            currentShapeHtml: "",
            textFontSize: 0,
            activeShape: null,
        };
    },
    mounted() {
        this.addHandler();
        document.addEventListener("click", this.handleClickOutside);
        document.addEventListener('mouseup', this.cancelShapeCreation);
        // Use window instead of document for keydown to ensure it works everywhere
        window.addEventListener('keydown', this.handleShortcutKey);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
        document.removeEventListener('mouseup', this.cancelShapeCreation);
        window.removeEventListener('keydown', this.handleShortcutKey);
    },
    /**
     * Keyboard shortcut handler for selecting Text tool with 'T'.
     * Only triggers if not focused in an input, textarea, or contenteditable.
     */
    handleShortcutKey(e) {
        // Only trigger if not typing in an input, textarea, or contenteditable
        const tag = (e.target && e.target.tagName ? e.target.tagName : '').toLowerCase();
        const isInput = tag === 'input' || tag === 'textarea' || (e.target && e.target.isContentEditable);
        if (isInput) return;
        // If T or t is pressed (and not with Ctrl/Alt/Meta)
        if ((e.key === 'T' || e.key === 't') && !e.ctrlKey && !e.altKey && !e.metaKey && !e.repeat) {
            // Use the correct Vuex mutation for createShape
            this.$store.commit('SET_CREATESHAPE', 'Text');
            // Optionally, visually highlight the Text tool in the header if needed
            e.preventDefault();
        }
    },
    computed: {
        parsedHtml(html) {
            const parser = new DOMParser();
            const elem = parser.parseFromString(html, 'text/html');
            return elem.body.innerText;
        },
        CanvasList() {
            return this.$store.getters.getCanvasInstances
        },
        CurrentCanvasIndex() {
            return this.$store.getters.getCanvasIndex
        },
        getrefs() {
            return this.$store.getters.getCanvasRefs
        },
        getActiveObject() {
            return this.$store.getters.getActiveObject
        },
        getActiveCanvasObjProps() {
            return this.$store.getters.getActiveObjectprops
        },
        getCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
        getActiveCanvasObjectsList() {
            return this.$store.getters.getCurrentActiveCanvasObjects
        },
        getcreateShapeType() {
            return this.$store.getters.getcreateShapeType
        },
        getZoom() {
            return this.$store.getters.getZoom
        },
        style() {
            return {
                top: this.top + 'px',
                left: this.left + 'px',
            };
        },
        checkLock() {
            let obj = this.$store.getters.getActiveObjectprops;

            if (obj !== null && obj?.lock == true) {
                return true
            } else {
                return false
            }
        }

    },
    watch: {
        // getCanvas: {
        //     handler(newValue) {
        //         // Note: `newValue` will be equal to `oldValue` here
        //         // on nested mutations as long as the object itself
        //         // hasn't been replaced.
        //         // console.log("canvas updated", newValue)
        //         // newValue.on("mouse:down", this.onMouseDown)
        //         // initAligningGuidelines(newValue)
        //         // addBorderOnObjectHover(newValue)

        //     },
        //     deep: false
        // },
        'getActiveCanvasObjProps.animationClassIn': {
            handler(updatedValues) {
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClass: updatedValues
                });
            }
        },
        'getActiveCanvasObjProps.fontfamily': {
            handler() {
                // console.log(updatedValues)
                this.$forceUpdate();
            }
        },
        'getActiveCanvasObjProps.animationDelayIn': {
            handler(updatedValues) {
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationDelay: updatedValues
                });
            }
        },
        'getActiveCanvasObjProps.animationDurationIn': {
            handler(updatedValues) {
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationDuration: updatedValues
                });
            }
        },
        'getActiveCanvasObjProps.animationClassOut': {
            handler(updatedValues) {
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClass: updatedValues
                });
            }
        },
        'getActiveCanvasObjProps.animationDelayOut': {
            handler(updatedValues) {
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationDelay: updatedValues
                });
            }
        },
        'getActiveCanvasObjProps.animationDurationOut': {
            handler(updatedValues) {
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationDuration: updatedValues
                });
            }
        },
        'getActiveCanvasObjProps.animationClassLoop': {
            handler(updatedValues) {
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClass: updatedValues
                });
            }
        },
        'getActiveCanvasObjProps.animationLoop': {
            handler(updatedValues) {
                if (updatedValues === true) {
                    this.$store.dispatch("setCurrentObjectProperties", {
                        animationDelay: 0,
                    });
                }
            }
        },
        'getActiveCanvasObjProps.animationLoopDuration': {
            handler(updatedValues) {
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationDuration: updatedValues,
                });
            }
        }
    },
    methods: {
        addPropsInscreen() {
            let list = localStorage.getItem("ppTi");
            debugger // eslint-disable-line no-debugger
            if (list) {
                // let jsonparse = JSON.parse(list);
                // let jsonparse = JSON.parse(list);
                let input = document.querySelector('input[name="hiddenval"]');
                let input2 = document.querySelector('input[name="hiddenvalresolution"]');
                if (input) {
                    let jsonparse = JSON.parse(input.value);
                    let jsonparse2 = JSON.parse(input2.value);
                    this.$store.dispatch("setCurrentCanvasDimensions", { width: parseInt(jsonparse2.width), height: parseInt(jsonparse2.height) })
                    this.$store.dispatch("setZoom", jsonparse2.zoom)
                    jsonparse.map(x => this.$store.dispatch("addObjectInCanvas", x));
                    this.$nextTick(() => {
                        // console.log('DOM has been updated');
                        // Perform actions after the DOM has been updated
                    });
                }
            }
        },
        handleClickOutside(event) {
            if (
                this.$refs.canvasWrapperHere &&
                this.$refs.canvasWrapperHere.contains(event.target) &&
                this.$refs.canvasWrapperHere === event.target
            ) {
                let obj = this.getActiveCanvasObjProps;
                if (obj.type === "text" && obj.editable === true) {
                    // this.setCurrentTargetnull();
                } else {
                    this.setCurrentTargetnull();
                }
            }
        },
        transitionComplete() {
            // This function will be called after the transition is complete
            // Perform any other actions you want here
            if (this.getActiveCanvasObjProps.animationClassIn !== "") {
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClass: this.getActiveCanvasObjProps.animationClassIn
                });
            } else {

                // console.log("Transition is complete!");

            }
            if (this.getActiveCanvasObjProps.animationClassOut !== "") {
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClass: this.getActiveCanvasObjProps.animationClassOut
                });
            } else {

                // console.log("Transition is complete!");

            }
            if (this.getActiveCanvasObjProps.animationClassLoop !== "") {
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClass: this.getActiveCanvasObjProps.animationClassLoop
                });
            } else {

                // console.log("Transition is complete!");
            }

            // if(this.getActiveCanvasObjProps.animationDelayIn != 0){
            //     this.$store.dispatch("setCurrentObjectProperties", {
            //         animationDelay: this.getActiveCanvasObjProps.animationDelayIn
            //         });
            // } else if(this.getActiveCanvasObjProps.animationDurationOut != 0){
            //     this.$store.dispatch("setCurrentObjectProperties", {
            //         animationDuration: this.getActiveCanvasObjProps.animationDurationIn
            //         });
            // } else {
            //     // console.log("Transition duration is complete!");
            // }

            // if(this.getActiveCanvasObjProps.animationDelayIn != 0){
            //     this.$store.dispatch("setCurrentObjectProperties", {
            //         animationDelay: this.getActiveCanvasObjProps.animationDelayIn
            //         });
            // } else if(this.getActiveCanvasObjProps.animationDurationOut != 0){
            //     this.$store.dispatch("setCurrentObjectProperties", {
            //         animationDuration: this.getActiveCanvasObjProps.animationDurationIn
            //         });
            // } else {
            //     // console.log("Transition duration is complete!");
            // }
        },
        onsetobj(event, type) {
            debugger // eslint-disable-line no-debugger
            if (type === "text") {
                this.$store.dispatch("setCurrentObjectProperties", {
                    // width: event.target?.children[0].children[0]?.offsetWidth / this.$store.getters.getZoom,
                    // height: event.target?.children[0].children[0]?.offsetHeight / this.$store.getters.getZoom,
                    // width: event.target?.offsetWidth / this.$store.getters.getZoom,
                    // height: event.target?.offsetHeight / this.$store.getters.getZoom,
                    editable: false,
                });
            }
        },
        onInputedit(e) {

            // console.log(e.target.innerText);
            this.$store.dispatch("setCurrentObjectProperties", {
                text: [e.target.innerText],

                // text: e.target.textContent,
            });
        },
        editonDblClick(event, type) {
            if (type === "text") {
                if (event.target.classList.contains("targetE")) {

                    const element = event.target.firstChild.firstChild;
                    element.contentEditable = true;

                    element.focus();

                    var range = document.createRange();
                    range.selectNodeContents(element);
                    var selection = window.getSelection();

                    selection.removeAllRanges();
                    selection.addRange(range);

                }
                // console.log(event.target)
                this.$store.dispatch("setCurrentObjectProperties", {
                    editable: true,
                });

            }

        },
        addEffect(obj) {

            switch (obj.effectType?.type) {
                case 'shadow':
                    return this.createShadow(obj.effectType)
                case 'lift':
                    return this.createLift(obj.effectType)

                default:
                    ''
                    break;
            }

        },
        addRotate(obj) {


            return `rotate(${obj.rotate}deg)`
        },
        createShadow(obj) {


            let radius = obj.offset / 10;
            let Hshadow = radius * Math.sin(Math.PI * 2 * obj.direction / 360);
            let Yshadow = radius * Math.cos(Math.PI * 2 * obj.direction / 360);
            let blur = obj.blur / 10;
            let color = obj?.color.replace(")", "," + obj.transparency / 100 + ")").replace("rgb", "rgba");
            let shadow = `${Hshadow}px ${Yshadow}px ${blur}px ${color}`;
            // console.log(shadow)
            return shadow
        },
        createLift(obj) {


            let intensity = obj.intensity;

            let lift = `7.5px 0px ${obj.intensity * .5}px rgba(0,0,0, ${(intensity * .75) / 100})`;
            // console.log(lift)
            return lift
        },
        createHollow(obj) {
            if (obj.effectType?.type === "hollow") {
                let thickness = obj?.effectType?.thickness;
                let holow = "";
                if (obj) {
                    holow = {
                        caretColor: obj?.color,
                        "-webkit-text-stroke": `${thickness / 18}px ${obj?.color}`,
                        "-webkit-text-fill-color": `transparent`,
                    }
                    return (holow)
                }

            } else {
                return ""

            }

        },
        createSplice(obj) {
            if (obj.effectType?.type === "splice") {
                if (obj) {
                    let thickness = obj?.effectType?.thickness;
                    let radius = obj.effectType?.offset / 18;
                    let Hshadow = radius * Math.sin(Math.PI * 2 * obj.effectType?.direction / 360);
                    let Yshadow = radius * Math.cos(Math.PI * 2 * obj.effectType?.direction / 360);
                    let color = obj.color;
                    let shadow = `${Hshadow}px ${Yshadow}px ${0}px ${color}`;
                    let holow = {
                        textShadow: shadow,
                        caretColor: obj?.effectType?.color,
                        "-webkit-text-stroke": `${thickness / 18}px ${obj?.effectType?.color}`,
                        "-webkit-text-fill-color": `transparent`,
                    }
                    return holow
                }
            } else {
                return ""

            }

        },
        createEcho(obj) {
            if (obj.effectType?.type === "echo") {
                if (obj) {
                    let radius = obj.effectType?.offset / 10;
                    let Hshadow = radius * Math.sin(Math.PI * 2 * obj.effectType?.direction / 360);
                    let Yshadow = radius * Math.cos(Math.PI * 2 * obj.effectType?.direction / 360);
                    let color = obj.effectType?.color.replace(')', ', 0.50)').replace('rgb', 'rgba');
                    let color2 = obj.effectType?.color.replace(')', ', 0.30)').replace('rgb', 'rgba');
                    let shadow = `${Hshadow}px ${Yshadow}px ${0}px ${color} , ${Hshadow * 2}px ${Yshadow * 2}px ${0}px ${color2}`;
                    let echo = {
                        textShadow: shadow,
                    }
                    return echo
                }
            } else {
                return ""

            }

        },
        createGlitch(obj) {
            if (obj.effectType?.type === "glitch") {
                if (obj) {
                    let radius = obj.effectType?.offset / 15;
                    let Hshadow = radius * Math.sin(Math.PI * 2 * obj.effectType?.direction / 360);
                    let Yshadow = radius * Math.cos(Math.PI * 2 * obj.effectType?.direction / 360);
                    let color = obj.effectType?.color;
                    let shadow = `${Hshadow}px ${Yshadow}px ${0}px rgb(0, 255, 255) , ${-(Hshadow)}px ${-(Yshadow)}px ${0}px ${color}`;
                    let echo = {
                        textShadow: shadow,
                    }
                    return echo
                }
            } else {
                return ""

            }

        },
        createAnimationVar(animationClass, duration, delay, motionDuration) {
            let obj = {
                '--animate-motion-duration': motionDuration * 1000 + 'ms',
                '--animate-duration': duration * 1000 + 'ms',
                '--animate-delay': delay * 1000 + 'ms',
            }
            return animationClass !== "" ? obj : {}
        },
        createNeon(obj) {
            if (obj.effectType?.type === "neon") {
                if (obj) {
                    let createdColor = this.adjustColorIntensity(obj.color, obj.effectType?.intensity).newcolor;
                    let dropshadow = this.adjustColorIntensity(obj.color, obj.effectType?.intensity).dropdshadow;
                    let intensity = obj.effectType?.intensity;
                    let shadow = `drop-shadow(rgba(${this.hexToRgb(dropshadow).r}, ${this.hexToRgb(dropshadow).g}, ${this.hexToRgb(dropshadow).b}, 0.95) 0px 0px ${intensity > 50 ? intensity / 45 : 65 / 45}px) drop-shadow(rgba(${this.hexToRgb(obj.color).r}, ${this.hexToRgb(obj.color).g}, ${this.hexToRgb(obj.color).b}, 0.75) 0px 0px ${intensity > 50 ? intensity / 13 : 65 / 13}px) drop-shadow(rgba(${this.hexToRgb(obj.color).r}, ${this.hexToRgb(obj.color).g}, ${this.hexToRgb(obj.color).b}, 0.44) 0px 0px ${intensity / 8.2}px)`
                    let filter = {
                        color: createdColor,
                        filter: shadow,
                    }
                    return filter
                }
            } else {
                return ""

            }

        },
        hexToRgb(hexColor) {
            // Remove "#" from the beginning if present
            const colorString = hexColor.startsWith('#') ? hexColor.substring(1) : hexColor;

            // Parse the hexadecimal color components
            const r = parseInt(colorString.substring(0, 2), 16);
            const g = parseInt(colorString.substring(2, 4), 16);
            const b = parseInt(colorString.substring(4, 6), 16);

            // Return the RGB values as an object
            return { r: r, g: g, b: b };
        },
        adjustColorIntensity(color, intensity) {
            // Validate intensity value (should be between 0 and 100)
            if (intensity < 0 || intensity > 100) {
                throw new Error('Intensity value should be between 0 and 100');
            }

            // Convert color to HSL
            const rgb = color.match(/\w{2}/g).map(hex => parseInt(hex, 16));
            const r = rgb[0] / 255;
            const g = rgb[1] / 255;
            const b = rgb[2] / 255;

            const max = Math.max(r, g, b);
            const min = Math.min(r, g, b);
            let h, s, l = (max + min) / 2;

            if (max === min) {
                h = s = 0; // achromatic
            } else {
                const d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

                switch (max) {
                    case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                    case g: h = (b - r) / d + 2; break;
                    case b: h = (r - g) / d + 4; break;
                }

                h /= 6;
            }

            // Adjust lightness based on intensity
            l = l + (1 - l) * intensity / 100;
            l = Math.min(1, Math.max(0, l)); // Ensure lightness stays between 0 and 1

            // Convert back to RGB
            let rOut, gOut, bOut;

            if (s === 0) {
                rOut = gOut = bOut = l; // achromatic
            } else {
                const hue2rgb = (p, q, t) => {
                    if (t < 0) t += 1;
                    if (t > 1) t -= 1;
                    if (t < 1 / 6) return p + (q - p) * 6 * t;
                    if (t < 1 / 2) return q;
                    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                    return p;
                };

                const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                const p = 2 * l - q;

                rOut = hue2rgb(p, q, h + 1 / 3);
                gOut = hue2rgb(p, q, h);
                bOut = hue2rgb(p, q, h - 1 / 3);
            }

            // Convert back to hex color code
            const toHex = (c) => Math.round(c * 255).toString(16).padStart(2, '0');
            const newColor = `#${toHex(rOut)}${toHex(gOut)}${toHex(bOut)}`;
            // console.log("newColor")
            // console.log(newColor)

            // Calculate the drop-shadow color based on intensity
            const dropShadowR = r + (1 - r) * 20 / 100;
            const dropShadowG = g + (1 - g) * 20 / 100;
            const dropShadowB = b + (1 - b) * 20 / 100;
            const dropShadowColor = `#${toHex(dropShadowR)}${toHex(dropShadowG)}${toHex(dropShadowB)}`;
            // console.log("dropShadowColor")
            // console.log(dropShadowColor)

            return { newcolor: newColor, dropdshadow: dropShadowColor };
        },
        onCanvasDrop(event) {
            event.preventDefault();
            var obj = JSON.parse(event.dataTransfer.getData("imgs"));
            this.$store.dispatch("addObjectInCanvas", obj)

        },
        async setCurrentTarget(e, id) {
            let datat = e.currentTarget.getAttribute("data-type");
            let obj = { target: datat !== 'Line' ? e.target : e.currentTarget, id: id };
            // debugger // eslint-disable-line no-debugger
            let allObjs = this.getActiveCanvasObjectsList;
            let record = allObjs.find(x => x.editable === true);

            if (record) {
                let currentobjs = { target: document.querySelector(`[data-id-t=${record.id}]`), id: record.id };
                if (document.querySelector(`[data-id-t=${record.id}]`) !== e.currentTarget) {

                    await this.$store.dispatch("setCurrentObjectProperties", {
                        editable: false,
                    });

                    await this.$store.dispatch("setActiveObject", currentobjs);


                }

            }
            // console.log("called setCurrentTarget")
            // console.log(obj)
            this.$store.dispatch("setActiveObject", obj)
            this.$store.dispatch('set_active_sidepanel', 'Settings')
            if (this.getActiveCanvasObjProps.lock) {
                this.$store.dispatch('set_active_sidepanel', 'Photos')
            }


        },
        setCurrentTargetnull() {
            this.$store.dispatch("setActiveObject", null);
        },
        cloneObject() {
            debugger // eslint-disable-line no-debugger

            let canvas = this.getActiveCanvasObjProps;
            delete canvas["__ob__"]
            this.$store.dispatch("addObjectInCanvas",
                {
                    ...canvas,
                    id: canvas?.id.split("_")[0] + uuidv4(),
                    top: canvas?.top + 10,
                    left: canvas?.left + 10,
                }
            )
            this.close()
        },
        LockObj() {
            this.$store.dispatch("setCurrentObjectProperties", { lock: true });
            this.$store.dispatch("setActiveObject", null)
            this.$store.dispatch('set_active_sidepanel', 'Photos')
            this.close()
        },
        unLockObj() {
            this.$store.dispatch("setCurrentObjectProperties", { lock: false });
            this.close()
        },
        SendToBack() {
            let currentTarget = this.getActiveObject.id;
            if (currentTarget) {
                let oldindex = Array.from(document.querySelector(`[data-id-t='${currentTarget}']`).parentElement.children).findIndex(x => x.getAttribute("data-id-t") === currentTarget);
                let value = { oldindex, newIndex: 0 }
                this.$store.dispatch("zIndexObjects", value)
            }

        },
        bringFronts() {


            let currentTarget = this.getActiveObject.id;
            if (currentTarget) {
                let oldindex = Array.from(document.querySelector(`[data-id-t='${currentTarget}']`).parentElement.children).findIndex(x => x.getAttribute("data-id-t") === currentTarget);

                let value = { oldindex, newIndex: this.getActiveCanvasObjectsList.length - 1 }
                this.$store.dispatch("zIndexObjects", value)
            }
        },
        SendBackward() {
            let currentTarget = this.getActiveObject.id;
            if (currentTarget) {
                let oldindex = Array.from(document.querySelector(`[data-id-t='${currentTarget}']`).parentElement.children).findIndex(x => x.getAttribute("data-id-t") === currentTarget);
                if (parseInt(oldindex) !== 0) {
                    let value = { oldindex, newIndex: parseInt(oldindex) - 1 }
                    this.$store.dispatch("zIndexObjects", value)
                }

            }
        },
        BrignForward() {
            let currentTarget = this.getActiveObject.id;
            let objlist = this.getActiveCanvasObjectsList;
            if (currentTarget) {
                let oldindex = Array.from(document.querySelector(`[data-id-t='${currentTarget}']`).parentElement.children).findIndex(x => x.getAttribute("data-id-t") === currentTarget);
                if (parseInt(oldindex) !== (objlist.length - 1)) {
                    let value = { oldindex, newIndex: parseInt(oldindex) + 1 }
                    this.$store.dispatch("zIndexObjects", value)
                }

            }
        },
        handler(e) {
            //do stuff
            e.preventDefault();
        },
        close() {
            this.show = false;
            this.left = 0;
            this.top = 0;
        },
        open(evt) {


            // updates position of context menu 

            this.left = evt.offsetX + evt.target.offsetLeft;
            this.top = evt.offsetY + evt.target.offsetTop;
            // make element focused 
            this.show = true;
            // let canvas = this.getCanvas;
            // canvas.setActiveObject(evt.target)
        },
        isDelKey(e) {
            // return e.code === "Delete" || e.code === "Backspace";
            return e.code === "Delete";

        },
        addHandler() {

            window.addEventListener('keydown', this.onKeyDown);

        },
        removeHandler() {
            // let canvas = this.getCanvas;

            window.removeEventListener('keydown', this.onKeyDown);
            // canvas.off("mouse:down", this.onMouseDown)
        },

        onKeyDown(e) {


            if (!!this.getActiveObject && this.isDelKey(e)) {
                this.deleteObject()
            }

        },
        deleteObject() {
            let currentObj = this.getActiveObject;
            if (currentObj != null) {
                this.$store.dispatch("deleteObject", currentObj.id);
            }
            this.close();
        },
        // onMouseDowneve(e) {
        //     // console.log("calling everytime")
        //     // debugger // eslint-disable-line no-debugger
        //     // this.startX = (e.clientX / this.getZoom) - (e.target.offsetLeft / this.getZoom);
        //     // this.startY = e.clientY - e.target.offsetTop;

        //     if (this.getcreateShapeType !== '') {
        //         this.startX = (e.offsetX + e.target.offsetLeft) / this.getZoom;
        //         this.startY = (e.offsetY + e.target.offsetTop) / this.getZoom;
        //         this.addShape(this.getcreateShapeType);
        //         // console.log(e.target)

        //     }

        //     // console.log(this.startX, this.startY);
        //     // console.log(e.button);
        //     // console.log(e.target)
        //     if (e.button === 0 && !e.target.classList.contains("targetE")) {

        //         let obj = this.getActiveCanvasObjProps;
        //         if (obj.type === "text" && obj.editable === true) {

        //             // this.setCurrentTargetnull();
        //         } else {
        //             this.setCurrentTargetnull();
        //         }

        //     }
        //     if (e.button === 2 && e.target.classList.contains("targetE")) {

        //         this.open(e)
        //     } else {
        //         this.close(e)
        //     }
        // },

        // onMouseMoveEve(e) {
        //     if (this.getcreateShapeType !== '') {
        //         // console.log("mouseMoveCalled afnan");
        //         const fontSize = ((((e.offsetX + e.target.offsetLeft) / this.getZoom) - this.startX) / this.getZoom + (((e.offsetY + e.target.offsetTop) / this.getZoom) - this.startY) / this.getZoom) / 25;
        //         // console.log("fontsize: " + fontSize)
        //         this.textFontSize = fontSize;
        //         this.shapeWidth = ((e.offsetX + e.target.offsetLeft) / this.getZoom) - this.startX;
        //         this.shapeHeight = ((e.offsetY + e.target.offsetTop) / this.getZoom) - this.startY;
        //         // console.log(this.currentShapeHtml)

        //         if (this.currentShapeHtml) {
        //             this.currentShapeHtml.style.height = this.shapeHeight + "px";
        //             if (this.getcreateShapeType !== 'Line' && this.getcreateShapeType !== 'Text') {
        //                 this.currentShapeHtml.style.width = this.shapeWidth + "px";
        //                 this.currentShapeHtml.children[0].style.width = "100%";
        //                 // this.currentShapeHtml.children[0].style.width = this.shapeWidth + "px"
        //             }
        //             if (this.getcreateShapeType === 'Text') {
        //                 //    debugger // eslint-disable-line no-debugger


        //                 this.currentShapeHtml.style.width = this.shapeWidth + "px";

        //             }
        //             this.currentShapeHtml.children[0].style.height = '100%';
        //             // this.currentShapeHtml.children[0].style.height = this.shapeHeight + "px"

        //         }
        //     }
        //     // // console.log(this.shapeWidth,this.shapeHeight)
        // },

        onMouseDowneve(e) {
            if (this.getcreateShapeType !== '') {
                this.startX = e.offsetX;
                this.startY = e.offsetY;

                this.addShape(this.getcreateShapeType);

                if (this.currentShapeHtml) {
                    const el = this.currentShapeHtml;

                    el.style.position = 'absolute';
                    el.style.left = `${this.startX}px`;
                    el.style.top = `${this.startY}px`;

                    el.style.width = '1px';
                    el.style.height = '1px';

                    el.style.margin = '0';
                    el.style.padding = '0';
                    el.style.border = 'none';
                    el.style.boxSizing = 'border-box';

                    const child = el.children[0];
                    if (child) {
                        child.style.width = '100%';
                        child.style.height = '100%';
                        child.style.margin = '0';
                        child.style.padding = '0';
                        child.style.border = 'none';
                        child.style.boxSizing = 'border-box';
                    }
                }
            }

            if (e.button === 0 && !e.target.classList.contains("targetE")) {
                const obj = this.getActiveCanvasObjProps;
                if (!(obj.type === "text" && obj.editable === true)) {
                    this.setCurrentTargetnull();
                }
            }

            if (e.button === 2 && e.target.classList.contains("targetE")) {
                this.open(e);
            } else {
                this.close(e);
            }
        },

        onMouseMoveEve(e) {
            if (this.getcreateShapeType !== '' && this.currentShapeHtml) {
                if (this._resizeAnimationFrame) {
                    cancelAnimationFrame(this._resizeAnimationFrame);
                }

                this._resizeAnimationFrame = requestAnimationFrame(() => {
                    const el = this.currentShapeHtml;
                    const minSize = 5;

                    if (this.getcreateShapeType === 'Line') {
                        const currentX = e.offsetX;
                        const currentY = e.offsetY;

                        // Determine if drawing is more horizontal or vertical
                        const dx = Math.abs(currentX - this.startX);
                        const dy = Math.abs(currentY - this.startY);

                        // Always anchor at startX/startY
                        let newLeft = this.startX;
                        let newTop = this.startY;
                        let width = 2;
                        let height = 2;
                        let isHorizontal = dx > dy;

                        // Always use 2px thickness for both directions
                        const thickness = 2;
                        // Always use black as default color if not set
                        const color = (this.getActiveCanvasObjProps?.borderColor && this.getActiveCanvasObjProps?.borderColor !== "") ? this.getActiveCanvasObjProps.borderColor : '#000';

                        if (isHorizontal) {
                            // Set both width and height for horizontal line
                            width = Math.abs(currentX - this.startX);
                            height = thickness;
                            if (width < minSize) return;
                            if (currentX < this.startX) {
                                newLeft = currentX;
                            }
                        } else {
                            width = thickness;
                            height = Math.abs(currentY - this.startY);
                            if (height < minSize) return;
                            if (currentY < this.startY) {
                                newTop = currentY;
                            }
                        }

                        el.style.pointerEvents = 'none';

                        if (
                            el._lastWidth !== width ||
                            el._lastHeight !== height ||
                            el._lastLeft !== newLeft ||
                            el._lastTop !== newTop
                        ) {
                            el.style.left = `${newLeft}px`;
                            el.style.top = `${newTop}px`;
                            // Always set both width and height for both directions
                            el.style.width = `${width}px`;
                            el.style.height = `${height}px`;

                            el.style.borderTop = 'none';
                            el.style.borderLeft = 'none';
                            el.style.background = color;

                            const child = el.children[0];
                            if (child) {
                                child.style.width = '100%';
                                child.style.height = '100%';
                            }

                            this.shapeWidth = width;
                            this.shapeHeight = height;

                            el._lastWidth = width;
                            el._lastHeight = height;
                            el._lastLeft = newLeft;
                            el._lastTop = newTop;
                        }
                        return;
                    }

                    if (this.getcreateShapeType === 'Text') {
                        const currentX = e.offsetX;
                        const currentY = e.offsetY;

                        let newLeft = Math.min(this.startX, currentX);
                        let newTop = Math.min(this.startY, currentY);
                        let width = Math.abs(currentX - this.startX);
                        let height = Math.abs(currentY - this.startY);

                        if (width < minSize || height < minSize) return;

                        el.style.pointerEvents = 'none';

                        if (
                            el._lastWidth !== width ||
                            el._lastHeight !== height ||
                            el._lastLeft !== newLeft ||
                            el._lastTop !== newTop
                        ) {
                            el.style.left = `${newLeft}px`;
                            el.style.top = `${newTop}px`;
                            el.style.width = `${width}px`;
                            el.style.height = `${height}px`;

                            const child = el.children[0];
                            if (child) {
                                child.style.width = '100%';
                                child.style.height = '100%';
                            }

                            const fontSize = (width + height) / 50;
                            this.textFontSize = fontSize;
                            this.shapeWidth = width;
                            this.shapeHeight = height;

                            el._lastWidth = width;
                            el._lastHeight = height;
                            el._lastLeft = newLeft;
                            el._lastTop = newTop;
                        }
                        return;
                    }

                    const currentX = e.offsetX;
                    const currentY = e.offsetY;

                    let width = Math.abs(currentX - this.startX);
                    let height = Math.abs(currentY - this.startY);
                    const size = Math.max(Math.min(width, height), minSize);

                    width = size;
                    height = size;

                    const newLeft = this.startX;
                    const newTop = this.startY;

                    el.style.pointerEvents = 'none';
                    el.style.left = `${newLeft}px`;
                    el.style.top = `${newTop}px`;
                    el.style.width = `${width}px`;
                    el.style.height = `${height}px`;

                    const child = el.children[0];
                    if (child) {
                        child.style.width = '100%';
                        child.style.height = '100%';
                    }

                    const fontSize = (width + height) / 50;
                    this.textFontSize = fontSize;
                    this.shapeWidth = width;
                    this.shapeHeight = height;

                    el._lastWidth = width;
                    el._lastHeight = height;
                    el._lastLeft = newLeft;
                    el._lastTop = newTop;
                });
            }
        },

        removeBGofImage() {
            // Extract the image URL from activeObjectprops in the Vuex store
            const imageUrl = this.$store.state.activeObjectprops.url;
            // console.log('Active Object Props:', imageUrl);

            // Define the request body with the image URL
            const requestBody = {
                imgSource: imageUrl
            };

            // Define the fetch options
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            };

            // Send the POST request to the backend for background removal
            fetch(process.env.VUE_APP_SERVER_URL + '/remove-background', requestOptions)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Failed to remove background');
                    }
                    return response.json();
                })
                .then(data => {
                    // Assuming the backend sends back the processed image URL in response
                    const resultDataURL = data.resultDataURL;
                    // console.log("New URL:", resultDataURL);

                    // Test URL to replace the original image URL
                    // const testURL = 'https://www.gstatic.com/webp/gallery/1.jpg';

                    // // Replace the original image URL with the test URL
                    // document.querySelector('img').src = testURL;
                    this.$store.dispatch("setCurrentObjectProperties", { url: resultDataURL });
                    // Optionally, show a success message or handle further UI updates
                    // console.log('Background removed successfully!');
                })
                .catch(error => {
                    console.error('Error removing background:', error);
                    // Optionally, show an error message or handle error UI updates
                });
        },
        addShape(check) {

            if (check === "Text") {
                let id = `ellipse_${uuidv4()}`;
                this.$store.dispatch("addObjectInCanvas",
                    {

                        id: id,
                        type: 'text',
                        text: ["Welcome!"],
                        top: this.startY,
                        rotate: 0,
                        left: this.startX,
                        scaleX: 1,
                        scaleY: 1,
                        editable: false,
                        zoom: 1,
                        width: 300,
                        color: "#565d64",
                        height: 100,
                        opacity: 1,
                        fw: 400,
                        fs: 75,
                        align: "center",
                        fontfamily: 'arial',
                        textTransform: "",
                        italic: false,
                        underline: false,
                        lock: false,
                        lineHeight: 1.2,
                        letterSpacing: 0,
                        effectType: { type: "none" },
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClass: "",
                        animationClassLoop: "",
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationDelay: 0,
                        animationDuration: 2,
                        animationLoop: false,
                        animationLoopDuration: 2,
                    }
                )
                this.currentShapeID = id;
            } else if (check === "Ellipse") {
                let id = `ellipse_${uuidv4()}`;
                this.$store.dispatch("addObjectInCanvas",
                    {
                        id: id,
                        type: 'Ellipse',
                        top: this.startY,
                        left: this.startX,
                        rotate: 0,
                        scaleX: 1,
                        scaleY: 1,
                        zoom: 1,
                        width: 60,
                        color: "#565d64",
                        bgColor: "#a2a5a9",
                        borderRadius: 50,
                        height: 60,
                        opacity: 1,
                        lock: false,
                        borderColor: "#2f5479",
                        borderWidth: 0,
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClass: "",
                        animationClassLoop: "",
                        animationDelay: 0,
                        animationDuration: 2,
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationLoopDuration: 2,
                        animationLoop: false
                    }
                )
                this.currentShapeID = id;
            } else if (check === "Triangle") {
                let id = `triangle_${uuidv4()}`;
                this.$store.dispatch("addObjectInCanvas",
                    {
                        id: id,
                        type: 'Triangle',
                        top: this.startY,
                        left: this.startX,
                        rotate: 0,
                        scaleX: 1,
                        scaleY: 1,
                        zoom: 1,
                        width: 60,
                        bgColor: "#a2a5a9",
                        height: 100,
                        opacity: 1,
                        lock: false,
                        clip: `polygon(0% 0%, 100% 0%, 50% 100%)`,
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClass: "",
                        animationClassLoop: "",
                        animationDelay: 0,
                        animationDuration: 2,
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationLoopDuration: 2,
                        animationLoop: false
                    }
                )
                this.currentShapeID = id;
            }
            else if (check === "Rectangle") {
                let id = `rectangle_${uuidv4()}`;
                this.$store.dispatch("addObjectInCanvas",
                    {
                        id: id,
                        type: 'Rectangle',
                        top: this.startY,
                        left: this.startX,
                        rotate: 0,
                        scaleX: 1,
                        scaleY: 1,
                        zoom: 1,
                        width: 60,
                        bgColor: "#a2a5a9",
                        borderRadius: 0,
                        height: 60,
                        opacity: 1,
                        lock: false,
                        borderColor: "#2f5479",
                        borderWidth: 0,
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClass: "",
                        animationClassLoop: "",
                        animationDelay: 0,
                        animationDuration: 2,
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationLoopDuration: 2,
                        animationLoop: false
                    }
                )
                this.currentShapeID = id;

            } else {
                let id = `line_${uuidv4()}`;
                this.$store.dispatch("addObjectInCanvas",
                    {
                        id: id,
                        type: 'Line',
                        top: this.startY,
                        left: this.startX,
                        rotate: 0,
                        scaleX: 1,
                        scaleY: 1,
                        zoom: 1,
                        width: 2,
                        bgColor: "#a2a5a9",
                        borderRadius: 0,
                        height: 120,
                        opacity: 1,
                        lock: false,
                        borderColor: "#000", // Default to black
                        borderWidth: 2,
                        isInAnimationActive: false,
                        isOutAnimationActive: false,
                        isLoopAnimationActive: false,
                        AnimationSequence: [],
                        animationClassIn: "",
                        animationClassOut: "",
                        animationClass: "",
                        animationClassLoop: "",
                        animationDelay: 0,
                        animationDuration: 2,
                        animationDelayIn: 0,
                        animationDurationIn: 2,
                        animationDelayOut: 0,
                        animationDurationOut: 2,
                        animationLoopDuration: 2,
                        animationLoop: false
                    }
                )
                this.currentShapeID = id;

            }
            this.$nextTick(function () {

                this.currentShapeHtml = document.querySelector(`div[data-id-t="${this.currentShapeID}"]`)


            })

        },

        cancelShapeCreation() {
            if (this.getcreateShapeType !== '') {
                let obj = { target: this.currentShapeHtml, id: this.currentShapeID };
                if (this.currentShapeHtml) {
                    this.currentShapeHtml.style.pointerEvents = 'auto';
                }
                cancelAnimationFrame(this._resizeAnimationFrame);
                this.$store.dispatch("setActiveObject", obj);
                if (this.getcreateShapeType !== 'Line' && this.getcreateShapeType !== "Text") {
                    this.$store.dispatch("setCurrentObjectProperties", {
                        width: this.shapeWidth / this.getZoom, height: this.shapeHeight / this.getZoom
                    });
                } else if (this.getcreateShapeType === "Text") {
                    this.currentShapeHtml.style.height = "auto";
                    this.$store.dispatch("setCurrentObjectProperties", {
                        width: this.shapeWidth / this.getZoom,
                        // height: null,
                        // fs: this.textFontSize / this.getZoom
                    });
                }
                else if (this.getcreateShapeType === 'Line') {
                    // For Line, always set width=2 for vertical, height=2 for horizontal
                    let width = this.shapeWidth / this.getZoom;
                    let height = this.shapeHeight / this.getZoom;
                    // If vertical (height > width), force width to 2
                    if (height > width) {
                        width = 2;
                    } else {
                        height = 2;
                    }
                    this.$store.dispatch("setCurrentObjectProperties", {
                        width,
                        height
                    });
                }

                console.log("canceled");
                this.startX = null;
                this.startY = null;
                this.shapeWidth = 0;
                this.shapeHeight = 0;
                this.currentShapeID = null;
                this.currentShapeHtml = "";
                this.textFontSize = 0;
                this.$store.dispatch('createShape', '');
            }
        },
    },

    destroyed() {
        this.removeHandler();
    }

}
</script>
<style scoped>
.wordbreak {
    word-break: break-all;
}

.canvas-box {
    margin: 1rem auto;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    border: 3px solid transparent;

}

.noPointer {
    pointer-events: none;
    user-select: none;
}

.CanvasWrapper {
    flex: 1 1 0%;
}

.WrapperDiv {
    overflow: hidden;
}

/* .canvas-box:hover {
    border: 3px solid #8e42ff;
} */

.context-menu {
    position: absolute;
    width: 185px;
    z-index: 9;
    background-color: #fff;
    border: 1px solid rgba(64, 87, 109, 0.07);
    box-shadow: 0 2px 8px rgba(53, 71, 90, 0.2);
    border-radius: 4px;
    padding: 0.8rem 0;

}

.ContextMenuItemContainer {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 0.8rem;

}

.ContextMenuItemContainer:hover {
    background: rgba(0, 0, 0, 0.06);
}

.smallSize {
    font-size: 12px;
    margin-left: 10px;
}

.divider {
    margin-bottom: .5rem;
    margin-top: .5rem;
    border-color: rgb(221 226 229);
}

.inset-0 {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
}

.adujustVideo {
    object-fit: contain;
    width: 100%;
    height: 100%;

}

.targetE:not(.locked):hover .OverlayHov {
    opacity: 1;
}

.targetE.locked:hover {
    outline: #6baeff auto;
}

.OverlayHov {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.25);
    pointer-events: none;
    opacity: 0;
}



.inset-0 {
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
}

.select-text {
    -webkit-user-select: text;
    user-select: text;
}

.croshair.WrapperDiv {
    cursor: crosshair;
}

.kenburnClass {
    transform-origin: 50% 100% 0px;
    animation: kenburn 60s linear 0s infinite alternate;
}




@keyframes kenburn {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(1.5);
    }
}
</style>